<template>
  <div class="bequeath-type-container">
    <v-card class="bequeath-card elevation-11">
      <div class="icon-container">
        <v-img class="bequeath-icon" :src="icon" />
      </div>
      <div class="title-container">{{ title }}</div>
      <div class="info-container">{{ info }}</div>
      <div class="button-container">
        <GradientButton
          :title="buttonText"
          :small="true"
          :callout="'right'"
          @gradientButtonClicked="bequeath"
        />
      </div>
      <div v-if="!!bequeathments.length" class="existing-donations">
        <div
          v-for="(donation, index) in bequeathments"
          :key="index"
          class="donation-item"
        >
          <div class="donation-item-text">
            <span class="asset-name">{{ donation.assetDisplayName }}</span>
            <br />
            <span>{{ beneficiaryText(donation) }}</span>
            <v-divider class="my-1" />
          </div>
          <div class="donation-item-actions mt-3">
            <GradientButton
              :title="'Edit'"
              :buttonSize="'small'"
              :small="true"
              @gradientButtonClicked="editDonation(donation)"
            />
            <GradientButton
              :title="'Delete'"
              :buttonSize="'small'"
              :small="true"
              :fill="false"
              @gradientButtonClicked="deleteCheckDonation(donation)"
            />
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
  export default {
    name: 'BequeathTile',
    data() {
      return {
        beneficiaryDisplayNameRegex: new RegExp(/\b(?:trust|charity)\s*$/, 'i'),
      };
    },
    props: {
      icon: {
        required: false,
        default: require(`@/assets/shared/redesign/icons/money.svg`),
        type: String,
      },
      info: {
        required: true,
        default: '',
        type: String,
      },
      title: {
        required: true,
        default: '',
        type: String,
      },
      buttonText: {
        required: true,
        default: '',
        type: String,
      },
      bequeathments: {
        required: false,
        default: () => [],
        type: Array,
      },
    },
    methods: {
      bequeath() {
        this.$emit('bequeath');
      },
      beneficiaryText(donation) {
        if (donation.donationType === 'MONEY') {
          var text = '';
          donation.beneficiaries.forEach((beneficiary, index) => {
            if (index == 0) {
              text += beneficiary.beneficiaryDisplayName;
            } else if (donation.beneficiaries.length > index + 1) {
              text += ', ' + beneficiary.beneficiaryDisplayName;
            } else if (donation.beneficiaries.length == index + 1) {
              text += ' and ' + beneficiary.beneficiaryDisplayName;
            }
          });
          return text;
        } else {
          var text = '';
          donation.beneficiaries.forEach((beneficiary, index) => {
            if (index == 0) {
              text += this.textForBeneficiaryPercentage(beneficiary);
            } else if (donation.beneficiaries.length > index + 1) {
              text += ', ' + this.textForBeneficiaryPercentage(beneficiary);
            } else if (donation.beneficiaries.length == index + 1) {
              text += ' and ' + this.textForBeneficiaryPercentage(beneficiary);
            }
          });
          return text;
        }
      },
      textForBeneficiaryPercentage(beneficiary) {
        switch (beneficiary.beneficiaryType) {
          case 'Person':
            return `${beneficiary.percentage}% to ${beneficiary.beneficiaryDisplayName}`;
          case 'Charity':
            if (
              this.beneficiaryDisplayNameRegex.test(
                beneficiary.beneficiaryDisplayName
              )
            ) {
              return `${beneficiary.percentage}% to ${beneficiary.beneficiaryDisplayName}`;
            } else {
              return `${beneficiary.percentage}% to ${beneficiary.beneficiaryDisplayName} charity`;
            }
          case 'Trust':
            if (
              this.beneficiaryDisplayNameRegex.test(
                beneficiary.beneficiaryDisplayName
              )
            ) {
              return `${beneficiary.percentage}% to ${beneficiary.beneficiaryDisplayName}`;
            } else {
              return `${beneficiary.percentage}% to ${beneficiary.beneficiaryDisplayName} trust`;
            }
          default:
            return `${beneficiary.percentage}% to ${beneficiary.beneficiaryDisplayName}`;
        }
      },
      editDonation(donation) {
        this.$emit('editDonation', donation);
      },
      deleteCheckDonation(donation) {
        this.$emit('deleteCheckDonation', donation);
      },
    },
    created() {},
  };
</script>
<style scoped lang="scss">
  .bequeath-type-container {
    display: flex;
    flex-direction: column;
    .bequeath-card {
      position: relative;
      max-width: 410px;
      width: 410px;
      height: auto;
      padding: 24px;
      margin-top: 25px;
      .icon-container {
        margin-bottom: 8px;
      }

      .bequeath-icon {
        width: 48px;
        height: 48px;
      }
      .title-container {
        font-size: 22px;
        font-weight: 500;
        line-height: 33px;
        text-align: left;
        margin-bottom: 16px;
      }
      .info-container {
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        text-align: left;
      }
      .button-container {
        // padding: 20px 0;
        margin-top: 30px;
        margin-bottom: 30px;
      }
    }
    .donation-item {
      border-radius: 7px;
      background-color: #ffffff;
      padding: 7px;
      max-width: 310px;
      margin: 25px 40px 25px 25px;
      .donation-item-text {
        font-size: 16px;
        padding-left: 5px;

        .asset-name {
          font-weight: bold;
        }
      }
    }

    @media only screen and (min-width: 0px) and (max-width: 959px) {
      .bequeath-card {
        max-width: 100%;
        width: 100%;
      }
      .donation-item {
        margin: 25px 11px 25px 11px;
      }
    }
  }
  .existing-donations {
    padding-top: 24px;
    border-top: 1px solid #dfe2e5;
  }
</style>
